import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["button", "panel"]

  select(event) {
    event.preventDefault()
    const activeTab = event.currentTarget.dataset.tab
    const activeClass = this.data.get("activeClass")
    const inactiveClass = this.data.get("inactiveClass")

    this.buttonTargets.forEach(btn => {
      if (btn === event.currentTarget) {
        btn.className = btn.className.replace(inactiveClass, activeClass)
      } else {
        btn.className = btn.className.replace(activeClass, inactiveClass)
      }
    })

    this.panelTargets.forEach(panel => {
      if (panel.dataset.tab === activeTab) {
        panel.classList.remove('d-none')
      } else {
        panel.classList.add('d-none')
      }
    })
  }
}
